export default {
  baseErrorMessges: {
    required: "This field is required.",
    dataType: "This field is not of the correct type.",
    existingAsset: "An asset with this identifier already exists.",
    serialNoIsReq: "Serial number is required.",
    length: "This fields value must be",
    min: "The minimum length of this field has not been met.",
    max: "The maximum length of this field has been exceeded.",
    unique: "There is already an entry with this value",
    minCount: "The input must be a minimum of {minCount} characters.",
    maxCount: "The input must be a maximum of {maxCount} characters.",
    dataTypeFloat: "Only numbers and up to two decimal places are allowed in this field.",
    dataTypeInt: "Only whole numbers with a maximum of 19 digits are allowed in this field.",
    dataTypeString: "Only letters, numbers, and special characters are allowed in this field.",
    dataTypeGuid: "Please enter a valid GUID (e.g. 51d52cf1-83c9-4f02-b117-703ecb728b74).",
  },
};
